import { TherapistAction } from '../../../src/redux/actions/constant';

export const getAllTherapistDiciplineAction = (payload: any) => {
  return {
    type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
    payload,
  };
};
